import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductTransactionExportConfigurationContext } from '../../../../../../../../context/ProductTransactionExportConfigurationContext';
import { ProductTransactionExportConfigurationRequest } from '../../../../../../../../requests/productTransactionExportConfiguration.request';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import {
  DeleteProductTransactionExportConfigurationInput,
  ProductTransactionExportConfigurationInput,
} from '../../../../../../../../types/product_transaction_export_configuration';
import { Routing } from '../../../../../../../../util/routes.util';
import { DeleteModal } from '../../../../../../../../VentoryUI/components/common/Modal';
import { translate } from '../../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';

interface DeleteProductTransactionExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteProductTransactionExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteProductTransactionExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { productTransactionExportConfigurations, setProductTransactionExportConfigurations } = useContext(
    ProductTransactionExportConfigurationContext,
  );

  const [remove, { loading }] = useRequest(ProductTransactionExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteProductTransactionExportConfigurationInput[] = [];

    for (const id of ids) {
      const config = productTransactionExportConfigurations.get(id);
      if (config) toDelete.push(new ProductTransactionExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      productTransactionExportConfigurations.delete(config.id);
    }

    setProductTransactionExportConfigurations(new Map(productTransactionExportConfigurations));
    handleClose();
    navigate(Routing.stock.history.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={translate({ key: TranslationKey.productTransactionExportConfigurationDeleteConfirmationText })}
      onConfirm={handleDelete}
      open={open}
      onClose={handleClose}
      loading={loading}
    />
  );
}
